import React from "react";
import {Grid, Skeleton, Stack} from "@mui/material";
import TourCardSkeleton from "@/components/common/tour-card/tour-card.skeleton";

const TourSearchResultsSkeleton = () => (
    <>
      <Grid
      container
        spacing={4}
        wrap="wrap"
        justifyContent="flex-start"
        width="100%"
        sx={{
          containerType: "inline-size",
          containerName: "tour-search-results-grid_skeleton"
        }}
        data-testid="tour-search-results-grid_skeleton"
      >
        {Array.from({length: 12}).map((_, index) => (
          <Grid
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              minWidth: "30rem"
            }}
            size="grow"
          >
            <TourCardSkeleton testId={index.toString()}/>
          </Grid>
        ))}
      </Grid>
      <Stack gap="1.6rem" alignItems="center" marginTop="4rem">
        <Skeleton width="20rem" data-testid="tour-search-results-pagination-label-skeleton" />
        <Stack direction="row" gap="1.6rem" alignItems="center" data-testid="tour-search-results-pagination-skeleton">
          <Skeleton variant="circular" height="4rem" width="4rem" />
          <Skeleton variant="circular" height="4rem" width="4rem" />
          <Skeleton variant="circular" height="4rem" width="4rem" />
          <Skeleton variant="circular" height="4rem" width="4rem" />
          <Skeleton variant="circular" height="4rem" width="4rem" />
        </Stack>
      </Stack>
    </>
  );

export default TourSearchResultsSkeleton;